export default {
	colors: {
		background: '#f6f5fc',
		primary: {
			lighter: '#e0e3ff',
			light: '#6674f4',
			main: '#5061fc',
			dark: '#3346f0'
		},
		gray: {
			100: '#E6E6E6',
			900: '#222222',
			200: '#BCBCBC'
		},
		danger: {
			light: '#F97171',
			main: '#FC5050',
			dark: '#F63131'
		},
		success: {
			main: '#51CA73'
		}
	}
};
